import { Carousel } from "../../ui/carousel/carousel";
import { SectionBlockHeader } from "../section-block-header/section-block-header";
import type { SectionStepsProps } from "./types";

interface ProgressIndicatorProps {
  isLast?: boolean;
}

export function ProgressIndicator({
  isLast = false,
}: Readonly<ProgressIndicatorProps>) {
  return (
    <div className="flex w-full items-center gap-2xs">
      {/* Outer Circle */}
      <div className="flex h-sm w-sm items-center justify-center rounded-full bg-surface/200">
        {/* Inner Circle */}
        <div className="h-2xs w-2xs rounded-full bg-surface/accent" />
      </div>

      {/* Line */}
      {!isLast && (
        <div className="h-[2px] flex-1 rounded-full bg-surface/200" />
      )}
    </div>
  );
}

function SectionSteps({ blok, ...context }: Readonly<SectionStepsProps>) {
  // PROGRESS BAR
  const showProgressBar = blok.progressBar;

  // GAP
  const gap = blok.gap;

  // ITEM SIZE
  const itemSize = blok.itemSize || 100;

  return (
    <Carousel className={gap}>
      {blok?.steps?.map((item, index) => (
        <div
          className="flex shrink-0 flex-col gap-xs"
          key={item._uid}
          style={{
            width: `${itemSize}px`,
          }}
        >
          {showProgressBar && (
            <ProgressIndicator
              isLast={index + 1 === (blok?.steps || []).length}
            />
          )}
          <SectionBlockHeader blok={item} {...context} />
        </div>
      ))}
    </Carousel>
  );
}

export { SectionSteps };
